// extracted by mini-css-extract-plugin
module.exports = {"tier":"tier--2vGVv","cryptoList":"cryptoList--1GfBy","item":"item--3o4VT"};